import React from 'react';

const ProgressIndicator = () => {
  return (
    <div className="mb-8 font-arial">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-4 w-full">
          {/* Step 1: Active */}
          <div className="w-10 h-10 bg-black text-white rounded-none flex items-center justify-center font-bold border-2 border-black">
            1
          </div>
          <div className="flex-1 h-1 bg-black"></div>
          
          {/* Step 2: Pending/Next */}
          <div className="w-10 h-10 bg-white text-gray-400 rounded-none flex items-center justify-center font-bold border-2 border-gray-300">
            2
          </div>
          <div className="flex-1 h-1 bg-gray-200"></div>
          
          {/* Step 3: Pending */}
          <div className="w-10 h-10 bg-white text-gray-400 rounded-none flex items-center justify-center font-bold border-2 border-gray-300">
            3
          </div>
        </div>
      </div>
      <div className="flex justify-between text-xs font-bold uppercase tracking-wider">
        <span className="text-black">Your Info</span>
        <span className="text-gray-400">Upload</span>
        <span className="text-gray-400">Done</span>
      </div>
    </div>
  );
};

export default ProgressIndicator;